var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 13.846V11.1794C22.6666 7.49746 19.6818 4.5127 15.9999 4.5127C12.318 4.5127 9.33325 7.49746 9.33325 11.1794V13.846M15.9999 19.846V22.5127M11.7333 28.5127H20.2666C22.5068 28.5127 23.6269 28.5127 24.4825 28.0767C25.2352 27.6932 25.8471 27.0813 26.2306 26.3287C26.6666 25.473 26.6666 24.3529 26.6666 22.1127V20.246C26.6666 18.0058 26.6666 16.8857 26.2306 16.0301C25.8471 15.2774 25.2352 14.6655 24.4825 14.282C23.6269 13.846 22.5068 13.846 20.2666 13.846H11.7333C9.49304 13.846 8.37294 13.846 7.51729 14.282C6.76464 14.6655 6.15272 15.2774 5.76923 16.0301C5.33325 16.8857 5.33325 18.0058 5.33325 20.246V22.1127C5.33325 24.3529 5.33325 25.473 5.76923 26.3287C6.15272 27.0813 6.76464 27.6932 7.51729 28.0767C8.37294 28.5127 9.49304 28.5127 11.7333 28.5127Z",
    stroke: "currentColor",
    strokeWidth: 2.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.75739fed0825f93028baa281d5e14f27.svg";
export { ForwardRef as ReactComponent };